import { isErrorResponse } from '@ori-events/failed-event-data';
export var Name = 'replace-subscription-failed';
export var ReplaceSubscriptionFailedEvent = Name;
export var isReplaceSubscriptionErrorResponse = function isReplaceSubscriptionErrorResponse(response) {
  return isErrorResponse(response);
};